import { useNode } from "@dashboard/hooks/hooks";
import { Tooltip, TooltipContent, TooltipTrigger } from "common-frontend-components";

import type { ReactNode } from "react";

export type BaseShapeProps = {
    label?: string;
    onClick?: () => void;
    mainProps?: React.SVGProps<SVGGElement>;
    tooltipContent?: ReactNode;
    enableTooltip?: boolean;
    tooltipClassName?: string;
    children: (props: { x: number; y: number }) => ReactNode;
};

export function BaseShape({
    onClick,
    mainProps,
    tooltipContent,
    enableTooltip = false,
    tooltipClassName = "bg-container text-on-container border border-container-outline rounded-lg",
    children,
}: BaseShapeProps) {
    const { x, y } = useNode();

    const content = (
        <g
            onClick={onClick}
            {...mainProps}
            style={{ cursor: onClick ? "pointer" : "default", ...mainProps?.style }}
        >
            {children({ x, y })}
        </g>
    );

    if (enableTooltip && tooltipContent) {
        return (
            <Tooltip>
                <TooltipTrigger asChild>{content}</TooltipTrigger>
                <TooltipContent sideOffset={8} className={tooltipClassName}>
                    {tooltipContent}
                </TooltipContent>
            </Tooltip>
        );
    }

    return content;
}
